<template>
  <div id="events">
    <div id="projects">
      <elastic-tab :menu="['Technical', 'Non Technical','Online']" @item-selected="onSelectedType" />
    </div>
    <div class="events">
      <div class="card event" v-for="event in events" :key="event.name" v-bind="event">
        <img
          v-gallery
          class="image"
          :src="require('@/assets/' + event.thumb)"
          :alt="'Flaminius 2k19 | A National Level Technical Symposium at Chennai - ' + event.name"
          :data-large="require('@/assets/' + event.image)"
          style="width:100%"
        />
        <div class="title">{{ event.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ElasticTab from "@/components/ElasticTab.vue";

export default {
  name: "EventPage",
  components: {
    ElasticTab
  },
  data() {
    return {
      eventsData: [
        {
          name: "FOOTBALL",
          image: "events/football.jpg",
          thumb: "events/football-thumb.jpg",
          type: "Non Technical"
        },
        {
          name: "BOX CRICKET",
          thumb: "events/cricket-thumb.jpg",
          image: "events/cricket.jpg",
          type: "Non Technical"
        },
        {
          name: "IPL AUCTION",
          image: "events/ipl-auction.jpg",
          thumb: "events/ipl-auction-thumb.jpg",
          type: "Non Technical"
        },
        {
          name: "CONNEXION",
          image: "events/connexion.jpg",
          thumb: "events/connexion-thumb.jpg",
          type: "Non Technical"
        },
        {
          name: "CARROM",
          image: "events/carrom.jpg",
          thumb: "events/carrom-thumb.jpg",
          type: "Non Technical"
        },
        {
          name: "CADD MODELLING",
          thumb: "events/cadd-modelling.jpg",
          image: "events/cadd-modelling-thumb.jpg",
          type: "Technical"
        },
        {
          name: "PAPER PRESENTATION",
          thumb: "events/paper-presentation-thumb.jpg",
          image: "events/paper-presentation.jpg",
          type: "Technical"
        },
        {
          name: "TECHNICAL CATECHIZE",
          image: "events/technical-catechize.jpg",
          thumb: "events/technical-catechize-thumb.jpg",
          type: "Technical"
        },
        {
          name: "Mr. MECHANIC",
          image: "events/mrmechanic.jpg",
          thumb: "events/mrmechanic-thumb.jpg",
          type: "Technical"
        },
        {
          name: "HYDRO ROCKETRY",
          image: "events/hydro-rocketry.jpg",
          thumb: "events/hydro-rocketry-thumb.jpg",
          type: "Technical"
        },
        {
          name: "MACHINIST",
          image: "events/machinist.jpg",
          thumb: "events/machinist-thumb.jpg",
          type: "Technical"
        },
        {
          name: "RC RACING",
          image: "events/rc-racing.jpg",
          thumb: "events/rc-racing-thumb.jpg",
          type: "Technical"
        },
        {
          name: "PHOTOGRAPHY",
          thumb: "events/photography-thumb.jpg",
          image: "events/photography.jpg",
          contacts: [
            { name: "DEVA RAJ", phone: "+91 7010066738" },
            { name: "RANJITH PARII", phone: "+91 8248853672" }
          ],
          type: "Online"
        },
        {
          name: "SHORT FILM",
          thumb: "events/short-film-thumb.jpg",
          image: "events/short-film.jpg",
          type: "Online"
        },
        {
          name: "TIK TOK",
          thumb: "events/tiktok-thumb.jpg",
          image: "events/tiktok.jpg",
          contacts: [
            { name: "INBASEKARAN R", phone: "+91 8807605455" },
            { name: "PRANESH KUMAR", phone: "+91 9677294656" }
          ],
          type: "Online"
        },
        {
          name: "MEME CREATION",
          thumb: "events/memecreation-thumb.jpg",
          image: "events/memecreation.jpg",
          type: "Online"
        },
        {
          name: "PUBG",
          image: "events/pubg.jpg",
          thumb: "events/pubg-thumb.jpg",
          type: "Online"
        }
      ],
      events: this.eventsData
    };
  },
  mounted() {
    this.onSelectedType("Technical");
  },
  methods: {
    onSelectedType(type) {
      this.events = this.eventsData.filter(i => i.type === type);
    }
  }
};
</script>

<style scoped>
#events {
  padding: 10vh 0;
  min-height: 80vh;
  color: white;
  text-align: center;
}

.events {
  display: flex;
  flex-wrap: wrap;
  margin-top: 2rem;
  justify-content: space-around;
}

.events-move {
  transition: all 300ms;
}
.events-enter-active {
  transition: all 200ms ease-out;
}

.events-leave-active {
  position: absolute;
  transition: all 200ms ease-in;
  transform: scale(0.5);
}

.events-enter,
.events-leave-to {
  opacity: 0;
}

.event {
  display: block;
  width: 12rem;
  padding: 0.5rem 0;
  margin: 0.5rem 0rem;
  border-radius: 0.2rem;
}

.event > .image {
  background: black;
  height: 12rem;
}

.event > .title {
  text-align: center;
  padding: 0;
  font-size: 1rem;
  color: var(--font-dark);
}

@media only screen and (min-width: 900px) {
  .event {
    width: 18rem;
    margin: 0.5rem 0;
  }

  .event > .image {
    height: 18rem;
  }
}
</style>
